module.exports = "<p>three-column works!</p>\r\n"